module.exports = __webpack_public_path__ + "src/assets/textures/leaves/tomato_leaf_color_map.jpg";